import { useEffect, useState } from 'react';
import { api } from '../../../api/cliente';
import type { ConfigCaptura } from '../../../api/tipos';

/** Uma consulta por carregamento da página, compartilhada por quem perguntar. */
let consulta: Promise<boolean> | null = null;

/**
 * A captura automática está liberada para esta conta?
 *
 * Durante a validação (`DFE_SOMENTE_ADMIN=on`) só administradores a veem; para
 * o cliente comum o menu e os atalhos somem, em vez de levar a uma tela de
 * "em breve". Enquanto a resposta não chega, vale `false` — esconder por meio
 * segundo é melhor que mostrar e tirar.
 */
export function useCapturaLiberada(): boolean {
  const [liberada, setLiberada] = useState(false);
  useEffect(() => {
    let vivo = true;
    consulta ??= api<ConfigCaptura>('/dfe/config')
      .then((c) => c.habilitado)
      .catch(() => {
        consulta = null; // tenta de novo na próxima montagem
        return false;
      });
    void consulta.then((v) => {
      if (vivo) setLiberada(v);
    });
    return () => {
      vivo = false;
    };
  }, []);
  return liberada;
}
